import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { api, fmtDate } from "@/lib/api";
import { Spinner } from "@/components/common";
import { Middle, Side } from "@/components/Perspective";
import { TopicActions } from "@/components/country/TopicActions";

export const TopicPerspectives = ({ liveId }) => {
  const [d, setD] = useState(null);
  const [open, setOpen] = useState([]);
  const [following, setFollowing] = useState([]);
  const [params] = useSearchParams();
  const pick = params.get("topic");
  useEffect(() => { api.get(`/live/${liveId}/topics`).then((r) => { setD(r.data); setFollowing(r.data.following || []); setOpen(r.data.topics?.length && pick == null ? [r.data.topics[0].topic] : []); }).catch(() => setD({ topics: [] })); }, [liveId]); // eslint-disable-line react-hooks/exhaustive-deps
  useEffect(() => {
    const t = d?.topics?.[Number(pick)];
    if (pick == null || !t) return undefined;
    setOpen((o) => (o.includes(t.topic) ? o : [...o, t.topic]));
    const timer = setTimeout(() => document.querySelector(`[data-testid="topic-${pick}"]`)?.scrollIntoView({ behavior: "smooth", block: "start" }), 150);
    return () => clearTimeout(timer);
  }, [d, pick]);
  if (!d) return <Spinner />;
  if (!d.topics?.length) return <p className="surface p-5 text-sm text-slate-500" data-testid="topics-generating">Middle is preparing its perspective on the debated topics. Check back shortly.</p>;
  return (
    <div className="max-w-5xl space-y-4" data-testid="topic-perspectives">
      <div>
        <p className="text-xs font-semibold uppercase tracking-wider text-[hsl(var(--facts))]">Topics that may decide the next election</p>
        <p className="mt-1 text-sm text-slate-500">{d.next_election && `Next election: ${d.next_election} · `}How the mainstream camps approach each topic, with Middle's evidence-first view. Updated daily{d.generated_at && `, last ${fmtDate(d.generated_at)}`}.</p>
      </div>
      <Accordion type="multiple" value={open} onValueChange={setOpen} className="space-y-3">
        {d.topics.map((t, i) => (
          <AccordionItem key={t.topic} value={t.topic} className="scroll-mt-20 surface border-0 px-5" data-testid={`topic-${i}`}>
            <AccordionTrigger className="text-left hover:no-underline" data-testid={`topic-trigger-${i}`}>
              <span><span className="block font-serif text-xl">{t.topic}</span>{t.why && <span className="mt-0.5 block text-sm font-normal text-slate-500">{t.why}</span>}</span>
            </AccordionTrigger>
            <AccordionContent className="space-y-3 pb-5">
              <TopicActions liveId={liveId} topic={t.topic} following={following} setFollowing={setFollowing} i={i} />
              <div className="grid gap-3 md:grid-cols-2">
                <Side label={t.left_label} s={t.left} testid={`topic-left-${i}`} />
                <Side label={t.right_label} s={t.right} testid={`topic-right-${i}`} />
              </div>
              <Middle m={t.middle} testid={`topic-middle-${i}`} />
            </AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
      <p className="text-[11px] text-slate-400">AI-written from verified Facts and official statistics. Middle doesn't endorse any party or position.</p>
    </div>
  );
};
